import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { HubioTableComponent, HubioTableOptions } from '@hubio/hubio-common-components';
import { transactionsConfig } from '../../configs/transactions-table.config';
import { AuditRecord } from '../../models/dashboard.model';

@Component({
  selector: 'app-transactions-table',
  templateUrl: './transactions-table.component.html',
  styleUrls: ['./transactions-table.component.scss']
})
export class TransactionsTableComponent implements OnInit {

  @ViewChild('table', { static: true }) public table: HubioTableComponent;
  @Input() public data: AuditRecord[];
  @Output() public rowClick: EventEmitter<any> = new EventEmitter();

  public tableOptions: HubioTableOptions
  private tableConfig;

  constructor() { }

  ngOnInit(): void {
    this.initComponent();
  }

  ngAfterViewInit(): void {
    this.getData();
  }

  private initComponent() {
    this.initMetadata();
    this.initTableOptions();
  }

  initMetadata() {
    this.tableConfig = transactionsConfig.tableDefinition;
  }

  private initTableOptions() {
    this.tableOptions = {
      columns: this.tableConfig.columns,
      tooltip: this.tableConfig.tooltip,
      paginator: {
        paginate: false
      },
      cache: {
        cache: false
      }
    };
  }

  getData() {
    this.table.setData(this.data, 0);
  }

  handleRowClick(record: AuditRecord) {
    this.rowClick.emit(record);
  }
}
